import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';
import Breadcrumb from '../breadcrumb/Breadcrumb';

const Wrapper = styled.div<{ bgImg: string }>`
  display: flex;
  position: absolute;
  border-radius: 24px 24px 0 0;
  width: 564px;
  height: 134px;
  justify-content: center;
  top: 5%;

  background-image: url(${(props) => props.bgImg});
  background-size: 564px 134px;

  @media (max-width: ${mobilePoint}) {
    width: 100%;
    height: 200px;
    top: 0;
    border-radius: 0;
    background-size: 100% 200px;
  }
`;
const LinkText = styled.div`
  position: absolute;
  left: 48px;
  top: 35px;
  font-size: 14px;
  color: ${colors.white};
`;
const Title = styled.div`
  font-family: NotoSansTC-Bold;
  position: absolute;
  top: 24px;
  font-size: 28px;
  color: ${colors.white};
  cursor: default;
  @media (max-width: ${mobilePoint}) {
    top: 90px;
    left: 48px;
  }
`;
const CardImg = styled.img`
  height: 128px;
  position: absolute;
  top: -35px;
  right: 20px;
  @media (max-width: ${mobilePoint}) {
    height: 128px;
    top: 35px;
    right: 0px;
  }
`;

interface IProps {
  returnPageName: string;
  returnPageUrl?: string;
  title: string;
  buttonText?: string;
  buttonOnClick?: () => void;
  onClikcReturnPage?: () => void;
  bgImg: string;
  image: string;
}

const Banner: React.FC<IProps> = ({
  returnPageName,
  returnPageUrl,
  title,
  buttonText,
  buttonOnClick,
  onClikcReturnPage,
  bgImg,
  image,
}) => {
  return (
    <Wrapper bgImg={bgImg}>
      <LinkText>
        <Breadcrumb
          returnPageName={returnPageName}
          returnPageUrl={returnPageUrl}
          onClikcReturnPage={onClikcReturnPage}
        />
      </LinkText>
      <Title><h1>{title}</h1></Title>
      {buttonText && <button onClick={buttonOnClick}>{buttonText}</button>}
      <CardImg src={image} alt="" ></CardImg>
    </Wrapper>
  );
};

export default Banner;
